var map = {
	"./10.png": "./src/assets/images/map/ld/10.png",
	"./11.png": "./src/assets/images/map/ld/11.png",
	"./12.png": "./src/assets/images/map/ld/12.png",
	"./7.png": "./src/assets/images/map/ld/7.png",
	"./8.png": "./src/assets/images/map/ld/8.png",
	"./9.png": "./src/assets/images/map/ld/9.png",
	"./bg.png": "./src/assets/images/map/ld/bg.png",
	"./ico_ck1.png": "./src/assets/images/map/ld/ico_ck1.png",
	"./ico_ck2.png": "./src/assets/images/map/ld/ico_ck2.png",
	"./ico_jg1.png": "./src/assets/images/map/ld/ico_jg1.png",
	"./ico_jg2.png": "./src/assets/images/map/ld/ico_jg2.png",
	"./ico_ll1.png": "./src/assets/images/map/ld/ico_ll1.png",
	"./ico_ll2.png": "./src/assets/images/map/ld/ico_ll2.png",
	"./ico_ry.png": "./src/assets/images/map/ld/ico_ry.png",
	"./ico_wl1.png": "./src/assets/images/map/ld/ico_wl1.png",
	"./ico_wl2.png": "./src/assets/images/map/ld/ico_wl2.png",
	"./l-01.png": "./src/assets/images/map/ld/l-01.png",
	"./l-02.png": "./src/assets/images/map/ld/l-02.png",
	"./l-03.png": "./src/assets/images/map/ld/l-03.png",
	"./l-04.png": "./src/assets/images/map/ld/l-04.png",
	"./l-05.png": "./src/assets/images/map/ld/l-05.png",
	"./l-06.png": "./src/assets/images/map/ld/l-06.png",
	"./l-07.png": "./src/assets/images/map/ld/l-07.png",
	"./l-08.png": "./src/assets/images/map/ld/l-08.png",
	"./l-09.png": "./src/assets/images/map/ld/l-09.png",
	"./l-10.png": "./src/assets/images/map/ld/l-10.png",
	"./l-11.png": "./src/assets/images/map/ld/l-11.png",
	"./l-12.png": "./src/assets/images/map/ld/l-12.png",
	"./liugey.png": "./src/assets/images/map/ld/liugey.png",
	"./liugey2.png": "./src/assets/images/map/ld/liugey2.png",
	"./liugeyi.png": "./src/assets/images/map/ld/liugeyi.png",
	"./liugeyi2.png": "./src/assets/images/map/ld/liugeyi2.png",
	"./nav-bg.png": "./src/assets/images/map/ld/nav-bg.png",
	"./中国荔枝产业大会.png": "./src/assets/images/map/ld/中国荔枝产业大会.png",
	"./中国荔枝产业大会1.png": "./src/assets/images/map/ld/中国荔枝产业大会1.png",
	"./中国荔枝产业大会会址.png": "./src/assets/images/map/ld/中国荔枝产业大会会址.png",
	"./中国荔枝博物馆.png": "./src/assets/images/map/ld/中国荔枝博物馆.png",
	"./中国荔枝博物馆1.png": "./src/assets/images/map/ld/中国荔枝博物馆1.png",
	"./中国荔枝博览馆.png": "./src/assets/images/map/ld/中国荔枝博览馆.png",
	"./五化果园.png": "./src/assets/images/map/ld/五化果园.png",
	"./产业园信息管理平台.png": "./src/assets/images/map/ld/产业园信息管理平台.png",
	"./产业园信息管理平台1.png": "./src/assets/images/map/ld/产业园信息管理平台1.png",
	"./产业园信息管理平台2.png": "./src/assets/images/map/ld/产业园信息管理平台2.png",
	"./右上.png": "./src/assets/images/map/ld/右上.png",
	"./右下.png": "./src/assets/images/map/ld/右下.png",
	"./右下0.png": "./src/assets/images/map/ld/右下0.png",
	"./向下.png": "./src/assets/images/map/ld/向下.png",
	"./国家荔枝种质资源圃.png": "./src/assets/images/map/ld/国家荔枝种质资源圃.png",
	"./国家荔枝种质资源圃1.png": "./src/assets/images/map/ld/国家荔枝种质资源圃1.png",
	"./左上.png": "./src/assets/images/map/ld/左上.png",
	"./左下.png": "./src/assets/images/map/ld/左下.png",
	"./智慧荔园.png": "./src/assets/images/map/ld/智慧荔园.png",
	"./智慧荔园1.png": "./src/assets/images/map/ld/智慧荔园1.png",
	"./根子柏桥贡园.png": "./src/assets/images/map/ld/根子柏桥贡园.png",
	"./泗水滩底古荔园.png": "./src/assets/images/map/ld/泗水滩底古荔园.png",
	"./泗水滩底贡园.png": "./src/assets/images/map/ld/泗水滩底贡园.png",
	"./田头小站.png": "./src/assets/images/map/ld/田头小站.png",
	"./羊角禄段古荔园.png": "./src/assets/images/map/ld/羊角禄段古荔园.png",
	"./羊角禄段贡园.png": "./src/assets/images/map/ld/羊角禄段贡园.png",
	"./霞洞上河古荔园.png": "./src/assets/images/map/ld/霞洞上河古荔园.png",
	"./霞洞上河贡园.png": "./src/assets/images/map/ld/霞洞上河贡园.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/map/ld sync recursive ^\\.\\/.*\\.png$";